const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  logo: {
    color: 'white',
  },
  logoContainer: {
    marginTop: 0,
    marginLeft: 0,
  },
  form: {
    height: '100%',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  input: {
    width: '%100',
  },
  button: {
    marginLeft: 20,
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/Header/styles.js